import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { reminder } from "src/types";

const initialState: reminder.ReminderStateType = {
  reminder: {
    data: null,
    isLoading: false,
    error: null,
  },
};

const reminderSlice = createSlice({
  name: "reminder",
  initialState,
  reducers: {
    // get reminder
    getReminderRequest: (
      state: reminder.ReminderStateType,
      action: PayloadAction<any>
    ) => {
      state.reminder.isLoading = true;
      state.reminder.data = null;
      state.reminder.error = null;
    },
    getReminderSuccess: (
      state: reminder.ReminderStateType,
      action: PayloadAction<any>
    ) => {
      state.reminder.isLoading = false;
      state.reminder.data = action.payload;
      state.reminder.error = null;
    },
    getReminderError: (
      state: reminder.ReminderStateType,
      action: PayloadAction<any>
    ) => {
      state.reminder.isLoading = false;
      state.reminder.data = null;
      state.reminder.error = action.payload;
    },

    // create reminder
    createReminderRequest: (
      state: reminder.ReminderStateType,
      action: PayloadAction<any>
    ) => {
      state.reminder.isLoading = true;
      state.reminder.data = null;
      state.reminder.error = null;
    },
    createReminderSuccess: (
      state: reminder.ReminderStateType,
      action: PayloadAction<any>
    ) => {
      state.reminder.isLoading = false;
      state.reminder.data = action.payload;
      state.reminder.error = null;
    },
    createReminderError: (
      state: reminder.ReminderStateType,
      action: PayloadAction<any>
    ) => {
      state.reminder.isLoading = false;
      state.reminder.data = null;
      state.reminder.error = action.payload;
    },

    // update reminder
    updateReminderRequest: (
      state: reminder.ReminderStateType,
      action: PayloadAction<any>
    ) => {
      state.reminder.isLoading = true;
      state.reminder.error = null;
    },
    updateReminderSuccess: (
      state: reminder.ReminderStateType,
      action: PayloadAction<any>
    ) => {
      state.reminder.isLoading = false;
      state.reminder.data = action.payload;
      state.reminder.error = null;
    },
    updateReminderError: (
      state: reminder.ReminderStateType,
      action: PayloadAction<any>
    ) => {
      state.reminder.isLoading = false;
      state.reminder.error = action.payload;
    },
  },
});

export const {
  // get reminder
  getReminderRequest,
  getReminderSuccess,
  getReminderError,

  // create reminder
  createReminderRequest,
  createReminderSuccess,
  createReminderError,

  // update reminder
  updateReminderRequest,
  updateReminderSuccess,
  updateReminderError,
} = reminderSlice.actions;

export default reminderSlice.reducer;
